import astm from './Astm/Config';

export default {
  ...astm,
};
